type BrowserPopStateGuard = (event: PopStateEvent) => boolean;

export interface PendingNativeTraversal {
  readonly isExpectedState: () => boolean;
  readonly complete: (result: boolean) => void;
}

let activeGuard: BrowserPopStateGuard | null = null;
let installed: boolean = false;

const handlePopState = (event: PopStateEvent): void => {
  if (activeGuard?.(event)) {
    event.stopImmediatePropagation();
  }
};

export function installStateHistoryGuard(): void {
  if (installed || typeof window === 'undefined') return;

  installed = true;
  window.addEventListener('popstate', handlePopState, true);
}

export function setStateHistoryGuard(guard: BrowserPopStateGuard | null): void {
  activeGuard = guard;
}
